export default __webpack_public_path__ + "static/media/009-iceberg.3e23d183.svg";